const { client, loadToken } = require('./client');
export { loadToken };

export async function getRealtime(agency, stop_id) {
  var { data } = await client.get(`api/gtfs/realtime/${agency}/${stop_id}`);

  return data;
}

export async function getAssignedTags() {
  var { data } = await client.get('/gtfs/tags/assigned');
  return data;
}

export async function getTags() {
  var { data } = await client.get('/gtfs/tags');
  return data;
}


const all = { loadToken, getRealtime, getTags, getAssignedTags };

export default all;